
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[section]/[city]",
      function () {
        return require("private-next-pages/[section]/[city].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[section]/[city]"])
      });
    }
  